import React from 'react';
import PropTypes from 'prop-types';
import { Nav, NavItem } from 'reactstrap';
import { NavLink, withRouter } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { ROUTES, insertIdtoUrl, insertBusinessIdtoUrl } from 'constants/Routes.js';
import { getRole, getBusinessId } from 'constants/localStorageManager.js';
import { USERS } from 'constants/Users.js';
import { BUSINESS_ADMIN_NAV } from 'constants/NavRoutes.js';

function isDashboardActive(path) {
  return BUSINESS_ADMIN_NAV.DASHBOARD.includes(path);
}

function isQuestionActive(path) {
  return BUSINESS_ADMIN_NAV.SURVEY.includes(path);
}

function isUserActive(path) {
  return BUSINESS_ADMIN_NAV.USER.includes(path);
}

function isRedemptionActive(path) {
  return BUSINESS_ADMIN_NAV.REDEEM.includes(path);
}

const BusinessNavigation = ({ match }) => {
  const businessId = getBusinessId();
  const { path } = match;

  return (
    <div className="nav-menu">
      <div className=" top-header">
        <Nav>
          <NavItem className="header-nav-item">
            <NavLink
              isActive={isDashboardActive.bind(this, path)}
              to={insertIdtoUrl(ROUTES.BUSINESS_DASHBOARD_INDEX, businessId)}
              activeClassName="activeMenu"
            >
              <FontAwesomeIcon icon="tachometer-alt" />
              Dashboard
            </NavLink>
          </NavItem>
          <NavItem className="header-nav-item">
            <NavLink
              exact
              to={insertIdtoUrl(ROUTES.CUSTOM_SURVEY_LIST, businessId)}
              activeClassName="activeMenu"
            >
              <FontAwesomeIcon icon="map-marker-alt" />
              Surveys
            </NavLink>
          </NavItem>
          <NavItem className="header-nav-item">
            <NavLink
              exact
              to={insertIdtoUrl(ROUTES.REQUEST_BUSINESS_ADD_ONS, businessId)}
              activeClassName="activeMenu"
            >
              Add-Ons
            </NavLink>
          </NavItem>
          <NavItem className="header-nav-item">
            <NavLink
              isActive={isRedemptionActive.bind(this, path)}
              to={insertIdtoUrl(ROUTES.REWARD_ISSUED, businessId)}
              activeClassName="activeMenu"
            >
              <FontAwesomeIcon icon="sticky-note" />
              Participants
            </NavLink>
          </NavItem>
          <NavItem className="header-nav-item d-sm-block d-md-block d-lg-none">
            <NavLink
              to={insertIdtoUrl(ROUTES.EDIT_BUSINESS_BASIC_INFO, businessId)}
              activeClassName="activeMenu active-menu"
            >
              Manage Account
            </NavLink>
          </NavItem>
          <NavItem className="header-nav-item d-sm-block d-md-block d-lg-none">
            <NavLink
              to={insertIdtoUrl(ROUTES.USERS_LIST, businessId)}
              activeClassName="activeMenu active-menu"
            >
              Manage Users
            </NavLink>
          </NavItem>
          <NavItem className="header-nav-item d-sm-block d-md-block d-lg-none">
            <NavLink
              to={insertBusinessIdtoUrl(ROUTES.BUSINESS_USER_DETAIL, businessId)}
              activeClassName="activeMenu active-menu"
            >
              Manage Profile
            </NavLink>
          </NavItem>
        </Nav>
      </div>
    </div>
  );
};

BusinessNavigation.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
};

export default withRouter(BusinessNavigation);



// WEBPACK FOOTER //
// ./src/components/Business-admin/BusinessNavigation.js